import React from "react";
import ContactOne from "@/components/contact-one";
import Footer from "@/components/footer";
import GoogleMap from "@/components/google-map";
import Layout from "@/components/layout";
import MenuContextProvider from "@/context/menu-context";
import HeaderOne from "@/components/header-one";
import { graphql } from "gatsby"


const ContactTemplate = (props) => {
    let data = props.data.wpgraphql;

    function constructMetaData(page, currentPage) {
        let payload = {
            title: page.seo.title,
            description: page.seo.metaDesc,
            canonical: `https://topaper.gr${currentPage}`,
            fbTitle: page.seo.opengraphTitle ? page.seo.opengraphTitle : page.seo.title,
            fbDescription: page.seo.opengraphDescription ? page.seo.opengraphDescription : page.seo.metaDesc,
            fbUrl: `https://topaper.gr${currentPage}`,
            fbType: "website",
            locale: 'el',
            image: page.seo.opengraphImage ? page.seo.opengraphImage.sourceUrl : ""
        }
        return payload
    }

    return (
        <MenuContextProvider>
            <Layout serving={data.categories} metaData={constructMetaData(data.page, props.pageContext.currentPage)} >
                <HeaderOne serving={data.categories} />
                <div className="flex flex-wrap">
                    <h1 className="w-full text-center pb-4">Επικοινωνήστε μαζί μας</h1>
                    <div className="w-full md:w-1/2 p-4 md:p-8">
                        <GoogleMap extraClassName="contact-page" map="https://maps.google.com/maps?q=TOPaper%20%CE%A0%CE%BF%CE%BB%CF%85%CE%BE%CE%B5%CE%BD%CE%B9%CE%B4%CE%B7%CF%82%20%CE%A7%CE%B1%CF%81%CF%84%CE%B9%CE%BA%CE%B1%20%CE%95%CF%80%CE%B1%CF%81.%CE%9F%CE%B4.%20%CE%91%CF%81%CE%B9%CE%B4%CE%B1%CE%AF%CE%B1%CF%82-%CE%9B%CE%BF%CF%85%CF%84%CF%81%CF%8E%CE%BD%2C%20%CE%91%CE%BB%CE%BC%CF%89%CF%80%CE%AF%CE%B1%20584%2000&t=m&z=15&output=embed&iwloc=near" />
                    </div>
                    <div className="w-full md:w-1/2 p-4 md:p-8">
                        <GoogleMap extraClassName="contact-page" map="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3012.225947402007!2d22.05923791568392!3d40.976532979303954!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1357b28f0c275095%3A0xcdd7bb9616fd582!2zzprOsc-AzrXPhM6szr0gzpPOsc-Bzq3Phs63ICYgzpzOuc6xzr_Pjc67zrcsIM6Rz4HOuc60zrHOr86xIDU4NCAwMA!5e0!3m2!1sel!2sgr!4v1620294807287!5m2!1sel!2sgr" />
                    </div>
                    <div className="w-full md:w-1/2 p-4 md:p-8">
                        <GoogleMap extraClassName="contact-page" map="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1510.8470066938057!2d22.15518262698365!3d40.76875423929071!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1357b95ab4c39751%3A0xc46a4ffa94288ca5!2zzqHOrs6zzrEgzqbOtc-BzrHOr86_z4UgJiDOo861zrLOsc-Dz4TOv8-Fz4DPjM67zrXPic-CLCDOo866z43OtM-BzrEgNTg1IDAw!5e0!3m2!1sel!2sgr!4v1620294674086!5m2!1sel!2sgr" />
                    </div>
                    <div className="w-full md:w-1/2 p-4 md:p-8">
                        <GoogleMap extraClassName="contact-page" map="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3033.20739185513!2d21.67531171567153!3d40.51490687935379!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13577ccffa6e20d3%3A0xa07ba11b49f3866b!2zzp3Ov8-Dzr_Ous6_zrzOtc6vzr_PhSAxOSwgzqDPhM6_zrvOtc68zrHOkM60zrEgNTAyIDAw!5e0!3m2!1sel!2sgr!4v1620294726548!5m2!1sel!2sgr" />
                    </div>

                    <div className="w-full p-4 md:p-8">
                        <GoogleMap extraClassName="contact-page" map="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3028.5428254021526!2d22.977493215402138!3d40.617909379342215!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a8388d7cc11173%3A0xc86f1df068300fc3!2zzpnPgM-Azr_OtM-Bzr_OvM6vzr_PhSA4MSwgzpjOtc-Dz4POsc67zr_Ovc6vzrrOtyA1NDMgNTE!5e0!3m2!1sel!2sgr!4v1620644380931!5m2!1sel!2sgr" />
                    </div>

                </div>

                <ContactOne data={data.page.contactPageAcf.contactInformation} />
                <Footer />
            </Layout>
        </MenuContextProvider>
    );
};

export default ContactTemplate;

export const pageQuery = graphql`query GET_CONTACT_US($id: ID!) {
    wpgraphql {
        page(id: $id) {
            seo {
                canonical
                title
                metaDesc
                opengraphDescription
                opengraphTitle
                opengraphImage {
                    sourceUrl
                }
            }
            contactPageAcf{
                contactInformation{
                    title
                    subtitle
                    content
                }
            }
        }

        categories (first:500) {
            edges {
              node {
                name
                description
                slug
                categoryPageH1{
                  categoryImage{
                    altText
                    sourceUrl
                    imageFile {
                        childImageSharp {
                            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: BLURRED)
                        }
                    }
                  }
                }
                children {
                  edges {
                    node {
                      name
                      posts {
                        edges {
                          node {
                            title
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
        }
    }
}
`
